import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { WeekUnitCostDto } from 'ts-types/api.types';
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import Input from 'components/final-form/Input';
import axios from 'axios';
import { Modal, Grid, Button } from 'semantic-ui-react';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import { errorUtils } from 'utils/errorUtils';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import { addWeekPrice, editWeekPrice } from 'services/weekPricesSettings';
import PraxFormGrid from 'components/layout/PraxFormGrid';

interface Props extends MessageSourceProps {
  onCancel: () => void,
  onSave: () => void,
  modalOpen: boolean,
  addWeekClicked: boolean,
  yearWeekKey?: string,
  week?: WeekUnitCostDto
}

interface State {
  week?: Partial<WeekUnitCostDto>,
  errorMessage?: string,
}

class UpsertWeekPriceForm extends Component<Props, State> {

  cancelTokenSource = axios.CancelToken.source();

  constructor(props: Props) {
    super(props);


    this.state = {

    }
  }

  handleSubmit = (values: Partial<WeekUnitCostDto>): void => {

    const {yearWeekKey, onSave, addWeekClicked} = this.props;

    if (yearWeekKey && !addWeekClicked) {
      editWeekPrice(yearWeekKey, values, this.cancelTokenSource)
          .then(onSave)
          .catch((error: any) => this.handleError(error))
    } else {
      addWeekPrice(values, this.cancelTokenSource)
          .then(onSave)
          .catch((error: any) => this.handleError(error))
    }
  }

  handleError(error: any) {
    const {getMessage} = this.props;

    const knownErrors = [errorUtils.existingRole];
    let errorMessage = "";

    let specificError = undefined;
    if (error.response.data && error.response.data.violations) {
      specificError = error.response.data.violations
          .find((violation: any) => knownErrors.includes(violation.errorCode));
    }

    if (specificError) {
      errorMessage = getMessage(`error.${specificError.errorCode}`)
    } else {
      errorMessage = getMessage('error.general');
    }

    this.setErrorMessage(errorMessage)
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    })
  };

  render(): React.ReactNode {
    const {modalOpen, onCancel, getMessage, week} = this.props;

    return (
        <Modal
            open={modalOpen}
            style={{width: "400px"}}
            onClose={onCancel}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("header.navigation.weekPrices")}</Modal.Header>
          <FormModalContentContainer>
            <FinalForm
                onSubmit={(values) => this.handleSubmit(values)}
                initialValues={week}
                subscription={{pristine: true}}
                render={this.renderForm}
            />
          </FormModalContentContainer>
        </Modal>
    )
  };

  renderForm =({handleSubmit, submitting}: FormRenderProps): React.ReactNode => {
    const {getMessage, onCancel} = this.props;
    const {errorMessage} = this.state;

    return (
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <FormContent>
              {errorMessage
              && (
                  <StyledErrorMessage onDismiss={() => this.setErrorMessage()}>
                    {errorMessage}
                  </StyledErrorMessage>
              )
              }
              <PraxFormGrid>
                    <Grid.Row>
                      <Grid.Column width={5} verticalAlign="middle">
                        {getMessage("weekPrices.week")}:
                      </Grid.Column>
                      <Grid.Column width={11} verticalAlign="middle">
                        <Field
                            fluid
                            name="yearWeekKey"
                            component={Input}
                            disabled
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={5} verticalAlign="middle">
                        {getMessage("weekPrices.laboratoryFee")}:
                      </Grid.Column>
                      <Grid.Column width={11} verticalAlign="middle">
                        <Field
                            fluid
                            name="labaratoryFee"
                            component={Input}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={5} verticalAlign="middle">
                        {getMessage("weekPrices.pcrPoolSupplement")}:
                      </Grid.Column>
                      <Grid.Column width={11} verticalAlign="middle">
                        <Field
                            fluid
                            name="pcrPoolSupplement"
                            component={Input}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={5} verticalAlign="middle">
                        {getMessage("weekPrices.poolFee")}:
                      </Grid.Column>
                      <Grid.Column width={11} verticalAlign="middle">
                        <Field
                            fluid
                            name="poolFee"
                            component={Input}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={5} verticalAlign="middle">
                        {getMessage("weekPrices.contractFee")}:
                      </Grid.Column>
                      <Grid.Column width={11} verticalAlign="middle">
                        <Field
                            fluid
                            name="contractFee"
                            component={Input}
                        />
                      </Grid.Column>
                    </Grid.Row>
              </PraxFormGrid>
            </FormContent>
            <FormButtonsRow>
              <Button compact type="submit" primary disabled={submitting}>{getMessage("button.save")}</Button>
              <Button compact type="button" disabled={submitting}
                      onClick={onCancel}>{getMessage("button.cancel")}</Button>
            </FormButtonsRow>
          </FormContainer>
        </form>
    )
  };
}

export default withMessages(UpsertWeekPriceForm);
